// custom-freak.js — FreakCatt
// Limpo: CSS removido (está no base.css), JS do Swiper corrigido

document.addEventListener('DOMContentLoaded', function () {
  var related = document.querySelector('product-recommendations');
  if (!related) return;

  related.querySelectorAll('*').forEach(function (el) {
    el.classList.remove(
      'swiper',
      'swiper-container',
      'swiper-wrapper',
      'swiper-slide'
    );
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
  });
});